let audioCtx: AudioContext | null = null;

const getAudioCtx = (): AudioContext | null => {
  if (audioCtx) return audioCtx;
  try {
    const Ctor =
      window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctor) return null;
    audioCtx = new Ctor();
    return audioCtx;
  } catch {
    return null;
  }
};

const tone = (freq: number, durationMs: number, type: OscillatorType = 'sine', startDelayMs = 0) => {
  const ctx = getAudioCtx();
  if (!ctx) return;
  const startAt = ctx.currentTime + startDelayMs / 1000;
  const stopAt = startAt + durationMs / 1000;

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, startAt);
  gain.gain.linearRampToValueAtTime(0.15, startAt + 0.01);
  gain.gain.linearRampToValueAtTime(0, stopAt);
  osc.connect(gain).connect(ctx.destination);
  osc.start(startAt);
  osc.stop(stopAt);
};

export const playSuccess = () => {
  tone(880, 90);
  tone(1320, 90, 'sine', 90);
};

export const playError = () => {
  tone(220, 250, 'sawtooth');
};

export const vibrate = (ms: number) => {
  try {
    navigator.vibrate?.(ms);
  } catch {
    /* not supported */
  }
};
